import * as React from "react"

type AutoFocusHandler = (event: Event) => void

/**
 * Radix Dialog/Sheet/AlertDialog return focus to their *Trigger* on close. Most portal dialogs are
 * opened programmatically (row click, menu item, confirm()) and have no Trigger, so focus fell to
 * <body> and keyboard users lost their place (WCAG 2.4.3). Remember what had focus when the dialog
 * opened and put it back; a consumer's own handler still runs first and can preventDefault.
 */
export function useReturnFocus(onOpenAutoFocus?: AutoFocusHandler, onCloseAutoFocus?: AutoFocusHandler) {
  const returnTo = React.useRef<HTMLElement | null>(null)
  return {
    onOpenAutoFocus: (event: Event) => {
      const active = document.activeElement
      returnTo.current = active instanceof HTMLElement && active !== document.body ? active : null
      onOpenAutoFocus?.(event)
    },
    onCloseAutoFocus: (event: Event) => {
      onCloseAutoFocus?.(event)
      const el = returnTo.current
      returnTo.current = null
      if (event.defaultPrevented || !el?.isConnected) return
      event.preventDefault()
      el.focus()
    },
  }
}
